module.exports = __webpack_public_path__ + "static/media/BARBIT.789be0d9.JPG";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/BARBIT.JPG
// module id = 1402
// module chunks = 1